import script from "./Content.vue?vue&type=script&lang=ts&setup=true"
export * from "./Content.vue?vue&type=script&lang=ts&setup=true"

import "./Content.vue?vue&type=style&index=0&id=a2ea9c38&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2ea9c38"]])

export default __exports__